import { render } from "./Vente.vue?vue&type=template&id=62a37cad&scoped=true"
import script from "./Vente.vue?vue&type=script&lang=js"
export * from "./Vente.vue?vue&type=script&lang=js"

import "./Vente.vue?vue&type=style&index=0&id=62a37cad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a37cad"]])

export default __exports__